import React, { useState } from "react";
import styled from "styled-components";
import TextHTML from "@motorata/base-ui.components.atoms.text-html";
import { Box, Grid, Row } from "@motorata/base-ui.components.atoms._atoms";
import Accordion from "@motorata/base-ui.components.molecules.accordion";
import Icon from "@motorata/base-ui.components.atoms.icon";
import { Label } from "@motorata/base-ui.components.atoms.typography";
import { translate } from "@motorata/base-ui.data";
import OfferContentReport from "./OfferContentReport";
import OfferContentEquipment from "./OfferContentEquipment";

const Property = ({ icon, label, value, onClick = () => {} }) => {
  return (
    <Row alignItems="center" onClick={onClick}>
      <Icon height="28px" width="28px" icon={icon} />
      <Box marginLeft="1rem">
        <Label type="third">{label}</Label>
        <Label type="secondary">{value}</Label>
      </Box>
    </Row>
  );
};

const OfferContentInfoProperties = ({ type, state, bodyType, year, course, gearBox, params, enginePower, engineCapacity, coordinator }) => {
  return (
    <Accordion title="Szczegóły oferty" wrapperProps={{ marginBottom: "S" }}>
      <PropertiesGrid>
        <Property icon="org-car" label="Rodzaj" value={translate(type)} onClick={coordinator ? () => {
          const cor = JSON.parse(coordinator)
          alert(`${cor?.name}, email: ${cor?.email}, tel: ${cor?.phone}`)
        } : () => {}} />
        <Property icon="org-state" label="Stan" value={translate(state)} />
        <Property icon="org-doors" label="Nadwozie" value={translate(bodyType)} />
        <Property icon="rokorg-calendar" label="Rok produkcji" value={year} />
        <Property
          icon="org-course"
          label="Przebieg"
          value={`${course === "" ? "0" : course} km`}
        />
        <Property
          icon="org-transmission"
          label="Skrzynia biegów"
          value={translate(gearBox)}
        />
        {params.color && (
          <Property
            icon="org-color"
            label="Kolor"
            value={`${translate(params.color)}${
              params.colorType ? ` (${translate(params.colorType)})` : ""
            }`}
          />
        )}
        <Property icon="org-power" label="Moc" value={`${enginePower} KM`} />
        <Property icon="org-capacity" label="Pojemność" value={`${engineCapacity} cm3`} />
        {params.country && (
          <Property
            icon="org-country"
            label="Kraj pochodzenia"
            value={translate(params.country)}
          />
        )}
        {params.vin && params.vin.length > 5 && (
          <Property
            icon="org-vin"
            label="VIN"
            value={params.vin}
          />
        )}
      </PropertiesGrid>
    </Accordion>
  );
};

const OfferContentInfoDescription = ({ description }) => {
  const [show, setShow] = useState(false);

  return (
    <Accordion collapseable={true} title="Opis oferty" wrapperProps={{ marginBottom: "S" }}>
      <TextHTML type="secondary" content={description} />
    </Accordion>
  );
};

const OfferContentInfo = ({ type, equipment, state, year, bodyType, course, gearBox, params, enginePower, engineCapacity, description, dtModified, coordinator }) => {

  return (
    <>
      <OfferContentInfoProperties type={type} state={state} bodyType={bodyType} year={year} course={course} gearBox={gearBox} params={params} engineCapacity={engineCapacity} enginePower={enginePower} coordinator={coordinator} />
      <OfferContentEquipment equipment={equipment} />
      {description && <OfferContentInfoDescription description={description} />}
      <OfferContentReport dtModified={dtModified} mobile={false} />
    </>
  );
};

export default OfferContentInfo;

const DescriptionButton = styled(Box)`
  width: calc(100% + 40px);
  margin-left: -20px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  margin-bottom: -20px !important;
  border-top: 1px solid ${({ theme }) => theme.color.fourth};
`;

const PropertiesGrid = styled(Grid)`
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 2rem;

  @media (max-width: 1300px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (max-width: 750px) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 1.5rem;
    grid-column-gap: 0.5rem;
  }

  @media (max-width: 550px) {
    grid-template-columns: 1fr;
    grid-gap: ${({ theme }) => theme.space.S};
  }
`;
